module.exports = __webpack_public_path__ + "static/media/team-erin-sd.6dc8f98b.jpg";